module.exports = __webpack_public_path__ + "static/media/Intro to VR.fadab53c.png";